<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-bullhorn"></i> News</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Title:</label>
                  <div class="control">
                    <span>{{item.Title}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Description:</label>
                    <div class="control">
                        <span>{{item.description}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Type:</label>
                    <div class="control">
                        <span>{{item.type}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <hr>
            </div>

            <div class="column is-12">
                <div class="columns box is-multiline">
                    <div class="column">
                        <div class="content" v-html="item.text">

                        </div>
                    </div>
                </div>
            </div>

            <div class="column is-2 is-offset-8 is-pulled-right"> 
                <router-link v-bind:to="{ name: 'news-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>                
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import NewsRepo from '../../repos/NewsRepo'
import lodash from 'lodash'

export default {
    name: 'news-show',
    components: {},
    data() {
        return {
            repo: new NewsRepo(this.$auth),
            item: {},
        }
    },
    created() {
        this.getNews(this.$route.params.id);
    },
    methods: {
        getNews(id) {
            this.repo.show(id).then(response => {
                this.item = response.data.data;
            });
        },
    },
    watch: {

    }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/news/Show.vue